import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { AnonymousLayout } from "@/layouts/AnonymousLayout/AnonymousLayout";
import { Typography } from "@/modules/theme/components/Typography/Typography";
import { useTheme } from "@/modules/theme/hooks/useTheme";
import { Theme } from "@/modules/theme/utils/createTheme";

import { ReactComponent as SendMessageImg } from "./send-message-image.svg";

const translationNamespace = "pages/ResetPasswordConfirmationPage";

const createResetPasswordConfirmationStyles = ({ spacing, palette }: Theme) => {
  return {
    contentWrapper: css({
      textAlign: "center",
      marginBottom: spacing(10),
      padding: spacing([0, 2]),
    }),
    img: css({
      marginBottom: spacing(6),
    }),
    heading: css({
      color: palette.default.text,
    }),
    description: css({
      marginTop: spacing(1),
    }),
  };
};

export const ResetPasswordConfirmationPage = () => {
  const { t } = useTranslation(translationNamespace);
  const theme = useTheme();
  const classes = createResetPasswordConfirmationStyles(theme);

  return (
    <AnonymousLayout>
      <div className={classes.contentWrapper}>
        <SendMessageImg className={classes.img} />
        <Typography variant="heading" className={classes.heading}>
          {t("Check your email")}
        </Typography>
        <Typography variant="contentMedium" className={classes.description}>
          {t("Check your email. We have sent you password reseting link.")}
        </Typography>
      </div>
    </AnonymousLayout>
  );
};
